import { Component, Input } from '@angular/core';

const UNICODE_OFFSET = 127397;

interface CountryCodeAndFlag {
  flag: string;
  countryCode: string;
}

@Component({
  selector: 'store-supported-countries',
  template: `
    <span class="supported-text">Supported Countries:</span>
    <div class="flags">
      <span
        *ngFor="let codeAndFlag of coutryCodeAndFlags"
        matTooltip="{{ codeAndFlag.countryCode }}"
        matTooltipPosition="below"
      >
        {{ codeAndFlag.flag }}
      </span>
    </div>
  `,
  styleUrls: ['./supported-countries.component.scss'],
  standalone: false,
})
export class SupportedCountriesComponent {
  @Input() set countryCodes(countryCodes: string[]) {
    countryCodes.forEach((countryCode) => {
      this.coutryCodeAndFlags.push({
        flag: this.getEmojiFlag(countryCode),
        countryCode,
      });
    });
  }
  coutryCodeAndFlags: CountryCodeAndFlag[] = [];

  private getEmojiFlag(countryCode: string): string {
    const chars = [...countryCode.toUpperCase()].map((c) => c.charCodeAt(0) + UNICODE_OFFSET);
    return String.fromCodePoint(...chars);
  }
}
